import { PAYMENT_TYPES } from '@vend/business-components'
import { ApiRetailerPaymentType } from '@vend/types'
import { Payment } from '../../models/payment'
import { Sale } from '../../models/sale'
import { ReduxCurrentSale } from '../../state/slices/currentSale/currentSaleSlice'
import { isReturn } from '../sale'

const LSPAY_ECOM_TYPE_ID = PAYMENT_TYPES.LIGHTSPEED_ECOM
export const LSPAY_ECOM_TYPE_NAME = 'lspayments (Online)'
export const LSPAY_ECOM_EXCHANGE_NOT_POSSIBLE_TOAST_KEY =
  'block.lspayEcom.exchange'

/**
 * Determines if the given payment type id is Lightspeed Ecomm.
 *
 * @param paymentTypeID The given payment type id.
 * @param paymentTypeName The given payment type name.
 *
 * @return True if the given payment type id and name is Lightspeed Ecomm, false otherwise.
 */
const isLspayEcomPaymentType = (
  paymentTypeID: number,
  paymentTypeName: string
): boolean => {
  return (
    LSPAY_ECOM_TYPE_ID === paymentTypeID &&
    LSPAY_ECOM_TYPE_NAME === paymentTypeName
  )
}

/**
 * Determines if the one of original sale payments in the sale is Lightspeed Ecomm.
 *
 * @param payments
 *        Payments on the original sale.
 *
 * @return {Boolean} True if a Lightspeed Ecomm payment exists in the collection, false otherwise.
 */
const hasLspayEcomPayment = (payments: Payment[]): boolean => {
  return payments.some(payment => {
    return isLspayEcomPaymentType(
      payment.paymentType.type_id,
      payment.paymentType.name
    )
  })
}

/**
 * Determines if the current sale is a Lightspeed eCom return.
 */
export const isReturnedESale = (sale: Sale | ReduxCurrentSale): boolean => {
  if (!isReturn(sale)) {
    return false
  }

  return hasLspayEcomPayment(sale.originalSalePayments)
}

/**
 * Returns a filtered collection of payment types for lspay ecom refund
 */
export const preparePaymentTypesForLSpayEcomRefund = (
  paymentTypes: ApiRetailerPaymentType[]
): ApiRetailerPaymentType[] => {
  return paymentTypes.reduce<ApiRetailerPaymentType[]>(
    (result, paymentType) => {
      if (paymentType.type_id === PAYMENT_TYPES.LIGHTSPEED_ECOM) {
        if (paymentType.name === LSPAY_ECOM_TYPE_NAME) {
          return [...result, { ...paymentType, name: 'LS Payment (Online)' }]
        }
        return result
      } else if (paymentType.type_id === PAYMENT_TYPES.LSPAY) {
        // hide all lighspeed payments for ecom return
        return result
      } else {
        return [...result, paymentType]
      }
    },
    []
  )
}
